// extracted by mini-css-extract-plugin
export default {"titleWrap":"styles_titleWrap__zDamE","title":"styles_title__crOwt","description":"styles_description__mApOs"};